module.exports = __webpack_public_path__ + "static/img/image@2x (7).e41216de.png";